import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import {
  InputClearValue,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { Icon } from "@progress/kendo-react-common";
import { useState, useEffect } from "react";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Stats } from "./stats";
import { ScheduleCard } from "./scheduleCard";
import {
  GetScheduleDetails,
  GetSchedules,
  Schedule,
  ScheduleDetails,
  ScheduleResource,
  UserScheduleDetails,
} from "@mikros/library";
import ApiServices from "../../service/apiService";
import { ScheduleDetailsFetch } from "./createSchedule/scheduleDetailsFetch";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../utils/apiConfig";
import { Utils } from "../../utils/utils";
import ErrorHandler from "../../utils/errorConfig";

export interface SchedulerProps {}

const EMPTY_VALUE = "";
const utils = new Utils();

export function Scheduler(props: SchedulerProps) {
  const intl = useIntl();

  const navigate = useNavigate();
  const location = useLocation();
  const errorInstance = ErrorHandler.getErrorInstance();

  const filterOptions = [
    intl.formatMessage({ id: "scheduleDetails.userReportStatus.inProgress" }),
    intl.formatMessage({ id: "scheduleDetails.userReportStatus.paused" }),
    intl.formatMessage({ id: "scheduleDetails.userReportStatus.completed" }),
    intl.formatMessage({ id: "scheduleDetails.userReportStatus.scheduled" }),
    intl.formatMessage({ id: "scheduleDetails.userReportStatus.stopped" }),
    intl.formatMessage({id:"scheduleDetails.userReportStatus.cancelled"}),
    intl.formatMessage({ id: "allValue" }),
  ];

  const [searchValue, setSearchValue] = useState<string>("");
  const [allSchedules, setAllSchedules] = useState<GetSchedules>(
    {} as GetSchedules
  );
  const [scheduleHomeScreen, setScheduleHomeScreen] = useState(true);
  const [scheduleFetchScreen, setFetchScheduleScreen] = useState(false);
  const [currSchedule, setCurrSchedule] = useState<any>();
  const [schedule, setSchedule] = useState<Schedule>({
    endOption: {},
  } as Schedule);
  const [filterValue, setFilterValue] = useState<string>(
    intl.formatMessage({ id: "allValue" })
  );
  const [srchCrs, setSrchCrs] = useState<GetSchedules>({} as GetSchedules);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("filterValue print", filterValue);

  const accountInstance = Account.getInstance();

  const [userScheduleDetails, setUserScheduleDetails] =
    useState<GetScheduleDetails>({
      userSchedules: [{} as UserScheduleDetails],
    } as GetScheduleDetails);
  const [scheduleDetails, setScheduleDetails] = useState<GetScheduleDetails>({
    schedule: {} as ScheduleDetails,
  } as GetScheduleDetails);

  console.log("please print curr schedule in home screen", currSchedule);
  console.log("fetch screen state", scheduleFetchScreen);
  console.log("fetch schedules in home screen", scheduleDetails);
  console.log("fetch user schedules in home screen", userScheduleDetails);

  const applySearchAndFilter = (searchTerm: string, filter: string) => {
    let schedules = utils.deepCopy(srchCrs) as GetSchedules;
    console.log("schedules in apply and search filter", schedules);

    const statusFilter = filter.toUpperCase().replace(" ", "");
    if (statusFilter !== "ALL") {
      console.log("I am inside filter status", statusFilter);
      schedules.resources = schedules.resources.filter((schedule) => {
        switch (statusFilter) {
          case "COMPLETED":
            return schedule.status === "COMPLETED";
          case "PAUSED":
            return schedule.status === "PAUSED";
          case "COMPLETED":
            return schedule.status === "COMPLETED";
          case "STOPPED":
            return schedule.status === "STOPPED";
          case "INPROGRESS":
            return schedule.status === "ACTIVE";
          case "SCHEDULED":
            return schedule.status === "SCHEDULED";
          case "CANCELLED":
            return schedule.status === "CANCELLED";
          default:
            return true;
        }
      });
    }

    //apply search filter
    console.log("print search term value", searchTerm);
    if (searchTerm) {
      console.log("i entered search term", searchTerm);
      searchTerm = searchTerm.toLowerCase();
      schedules.resources = schedules?.resources.filter((schedule) =>
        schedule.scheduleName.toLowerCase().includes(searchTerm)
      );
    }
    //apply status filter

    schedules.resourceCount = schedules?.resources?.length;
    setAllSchedules(schedules);
  };

  const handleSearchValueChange = (e: TextBoxChangeEvent) => {
    const newSearchValue = e.value?.toString() || "";
    setSearchValue(newSearchValue);
    applySearchAndFilter(newSearchValue, filterValue);
  };

  const handleClear = () => {
    setSearchValue(EMPTY_VALUE);

    if (filterValue === "ALL") {
      let schedules = utils.deepCopy(srchCrs) as GetSchedules;
      setAllSchedules(schedules);
      return;
    }
    applySearchAndFilter("", filterValue);
  };

  const resetFilter = () => {
    setFilterValue(intl.formatMessage({ id: "allValue" }));
  };

  const handleFilter = (e: DropDownListChangeEvent) => {
    const newFilterValue = e.value.toString();
    setFilterValue(newFilterValue);
    applySearchAndFilter(searchValue?.toString() || "", newFilterValue);
  };

  const apiGetAllSchedules = () => {
    resetFilter();
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/schedule`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          let x = res as GetSchedules;

          if (x) {
            x.resources.sort(
              (a, b) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            );
            setAllSchedules(x);
            setSrchCrs(utils.deepCopy(x));
            console.log("schedule ids", res);
          }
        });
    }
  };

  const handleCreateSchedule = () => {
    navigate("/newSchedule", {
      state: intl.formatMessage({ id: "scheduler.createSchedule" }),
    });
  };

  const handleViewClick = (schedule: ScheduleResource) => {
    console.log("inside schedule handle view click");

    setScheduleHomeScreen(false);

    setFetchScheduleScreen(true);
    console.log("schedule id print", schedule.scheduleId);
    getScheduleInfo(schedule.scheduleId);

    setCurrSchedule(schedule);

    console.log("schedule data inside sched home screen", schedule);
  };

  async function getScheduleInfo(
    scheduleId: string
  ): Promise<GetScheduleDetails> {
    console.log("hi i am in getScheduleInfo");
    let x: GetScheduleDetails = {} as GetScheduleDetails;

    let api = ApiServices.getInstance();

    if (accountInstance.accntId) {
      x = await api
        .makeRequest(`${accountInstance.accntId}/schedule/${scheduleId}`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          setScheduleDetails(res);
          setUserScheduleDetails(res);
          console.log("get response", res);
          return res;
        });
    }

    return x as GetScheduleDetails;
  }

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
    console.log("filter value inside use effect of scheduler", filterValue);

    apiGetAllSchedules();
  }, []);

  useEffect(() => {
    if (
      location.state === intl.formatMessage({ id: "scheduler.fetchSchedule" })
    ) {
      setFetchScheduleScreen(true);
      setScheduleHomeScreen(false);
    } else if (
      location.state === intl.formatMessage({ id: "scheduler.schedules" })
    ) {
      setFetchScheduleScreen(false);
      setScheduleHomeScreen(true);
    }
  }, [location.state]);

  console.log(location.state);

  return (
    <div className="w-full h-full flex flex-col space-y-10 items-center">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/scheduler");
              }
            }}
          />
        </Dialog>
      )}
      {scheduleFetchScreen && (
        <div className="w-full h-full">
          <ScheduleDetailsFetch
            currentSchedule={currSchedule}
            scheduleModel={scheduleDetails}
            schedule={schedule}
            homeScreenState={setScheduleHomeScreen}
            fetchScreenState={setFetchScheduleScreen}
          />
        </div>
      )}

      {scheduleHomeScreen && (
        <div className="w-full flex mt-2 justify-between md:gap-0 gap-4 items-center">
          <Stats />
          <Stats />
          <Stats />
          <Stats />
        </div>
      )}

      {scheduleHomeScreen && (
        <div className="w-full flex justify-between items-center">
          <TextBox
            value={searchValue}
            onChange={handleSearchValueChange}
            placeholder={intl.formatMessage({ id: "search.title" })}
            suffix={() => (
              <>
                {searchValue !== EMPTY_VALUE && (
                  <InputClearValue onClick={handleClear}>
                    <Icon name="x" />
                  </InputClearValue>
                )}
              </>
            )}
            className="w-[45%] rounded-xl"
          />
          <div className="flex space-x-4 items-center justify-center">
            <DropDownList
              data={filterOptions}
              value={filterValue}
              className="w-40 text-sm"
              onChange={handleFilter}
            />
            <Button themeColor="primary">
              {/* Sort  */}
              <FormattedMessage id="scheduler.sort" />
            </Button>
            <Button
              onClick={() => {
                handleCreateSchedule();
              }}
              themeColor="primary"
            >
              <FormattedMessage id="scheduler.createSchedule" />+
            </Button>
          </div>
        </div>
      )}

      {/* <div > */}
      {/* {scheduleHomeScreen && (
        <div className="w-full h-full grid gap-y-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-16 pb-24">
          {
            allSchedules.resources?.length > 0 ?
          (allSchedules.resources?.map((element, index) => {
            return (
              <ScheduleCard
                key={index}
                scheduleCardResourse={element}
                homeScreenState={setScheduleHomeScreen}
                fetchScreenState={setFetchScheduleScreen}
                onReload={() => {
                  apiGetAllSchedules();
                }}
                currentScheduleFunction={setCurrSchedule}
                getScheduleDetails={() => getScheduleInfo(element.scheduleId)}
                click={() => handleViewClick(element)}
              />
            );
          })):(
            <div className="w-full h-full items-center justify-center">
              No schedules match the search condition
            </div>

          )
        
        }
        </div>
      )} */}

      {scheduleHomeScreen && (
        <div>
          <div className="w-full h-full pb-24">
            {allSchedules.resources?.length > 0 ? (
              <div className="grid gap-y-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-16">
                {allSchedules.resources.map((element, index) => (
                  <ScheduleCard
                    key={index}
                    scheduleCardResourse={element}
                    homeScreenState={setScheduleHomeScreen}
                    fetchScreenState={setFetchScheduleScreen}
                    onReload={() => {
                      apiGetAllSchedules();
                    }}
                    currentScheduleFunction={setCurrSchedule}
                    getScheduleDetails={() =>
                      getScheduleInfo(element.scheduleId)
                    }
                    click={() => handleViewClick(element)}
                  />
                ))}
              </div>
            ) : (
              <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                <FormattedMessage id="scheduler.noSchedules" />
              </div>
            )}
          </div>
          <div className="pb-[10%]"></div>
        </div>
      )}
    </div>
  );
}
